module.exports = " <div class=star :class=starType> <span v-for=\"itemClass in itemClasses\" :class=itemClass class=star-item track-by=$index></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/_eslint-loader@1.7.1@eslint-loader!./src/components/star/star.vue
// module id = 23
// module chunks = 1